import Vue from 'vue';
import Router from 'vue-router';
// import Home from './views/Home.vue'
import Questions from './views/Questions.vue';
import Products from './views/Products.vue';
import Customer from './views/Customer.vue';
import Complete from './views/Complete.vue';
import Navigation from './components/Navigation.vue';

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'questions',
      components: {
        default: Questions,
        navigation: Navigation
      } 
    },
    {
      path: '/products',
      name: 'products',
      components: {
        default: Products,
        navigation: Navigation
      } 
    },
    {
      path: '/Your-Details',
      name: 'Customer',
      components: {
        default: Customer,
        navigation: Navigation
      }
    },
    {
      path: '/complete',
      name: 'Complete',
      component: Complete
    }
  ]
})
